import { ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import { getUserData } from '@/auth/utils'
import axios from '@/libs/axios'
import { currency } from '@core/utils/filter'

export default function useDashboardPadrinho() {
  // Estados reativos
  const isLoading = ref(false)
  const comissoesData = ref([])
  const usuariosApadrinhados = ref([])
  const statsData = ref({
    totalUsuariosApadrinhados: 0,
    totalComissoes: 0,
    totalVendasApadrinhados: 0,
    totalPedidosGerados: 0,
    comissaoTotal: 0,
    comissaoPaga: 0,
    comissaoAPagar: 0,
  })

  // Função para calcular estatísticas
  const calculateStats = () => {
    const comissoes = comissoesData.value
    const userData = getUserData()

    let totalComissoes = 0
    let comissaoTotal = 0
    let comissaoPaga = 0
    let comissaoAPagar = 0
    let totalVendasApadrinhados = 0
    let totalPedidosGerados = 0

    console.log('Calculando estatísticas para padrinho ID:', userData.padrinho?.id)

    comissoes.forEach((comissao, index) => {
      const pedido = comissao.pedido_item?.pedido
      let valorComissao = 0

      // Verificar se o padrinho está associado como afiliado ou vendedor
      if (userData.padrinho.id === comissao.id_padrinho_afiliado) {
        valorComissao += Number(comissao.comissao_padrinho_afiliado) || 0
        console.log(`Comissão ${index + 1} - Padrinho Afiliado: R$ ${valorComissao}`)
      }

      if (userData.padrinho.id === comissao.id_padrinho_vendedor) {
        valorComissao += Number(comissao.comissao_padrinho_vendedor) || 0
        console.log(`Comissão ${index + 1} - Padrinho Vendedor: R$ ${valorComissao}`)
      }

      // Se não encontrou nos campos específicos, usar o campo genérico
      if (valorComissao === 0) {
        valorComissao = Number(comissao.comissao_padrinho) || 0
        console.log(`Comissão ${index + 1} - Padrinho Genérico: R$ ${valorComissao}`)
      }

      const valorTotalItem = Number(comissao.pedido_item?.valor_total_item) || 0
      
      if (valorComissao > 0) {
        totalComissoes += 1
        comissaoTotal += valorComissao
        totalPedidosGerados += 1

        // Comissões pagas/a pagar
        if (comissao.pago) {
          comissaoPaga += valorComissao
        } else {
          comissaoAPagar += valorComissao
        }

        // Status dos pedidos - vendas dos apadrinhados
        if (pedido?.status === 'Paid' || pedido?.status === 'Completed') {
          totalVendasApadrinhados += valorTotalItem
          console.log(`Venda confirmada apadrinhado: R$ ${valorTotalItem}`)
        }
      }
    })

    statsData.value = {
      totalUsuariosApadrinhados: usuariosApadrinhados.value.length,
      totalComissoes,
      totalVendasApadrinhados,
      totalPedidosGerados,
      comissaoTotal,
      comissaoPaga,
      comissaoAPagar,
    }

    console.log('Estatísticas Padrinho calculadas:', {
      ...statsData.value,
      comissaoTotal: `R$ ${statsData.value.comissaoTotal.toFixed(2)}`,
      comissaoPaga: `R$ ${statsData.value.comissaoPaga.toFixed(2)}`,
      comissaoAPagar: `R$ ${statsData.value.comissaoAPagar.toFixed(2)}`,
    })
  }

  // Função para buscar usuários apadrinhados
  const fetchUsuariosApadrinhados = async () => {
    try {
      const userData = getUserData()
      const padrinhoCodigo = userData?.padrinho?.codigo

      if (!padrinhoCodigo) {
        console.error('Código do padrinho não encontrado')
        return
      }

      console.log('Buscando usuários apadrinhados com código:', padrinhoCodigo)

      const response = await store.dispatch('app-adm-usuario/fetchUsers', {
        q: '',
        perPage: 1000,
        page: 1,
        sortBy: 'id',
        sortDesc: true,
        role: '',
        id_grupousuario: '',
        ativo: null,
        codigo: padrinhoCodigo,
      })

      const { users } = response.data
      usuariosApadrinhados.value = users || []
      
      statsData.value.totalUsuariosApadrinhados = usuariosApadrinhados.value.length
      console.log('Usuários apadrinhados encontrados:', statsData.value.totalUsuariosApadrinhados)
    } catch (error) {
      console.error('Erro ao buscar usuários apadrinhados:', error)
    }
  }

  // Função para buscar comissões do padrinho
  const fetchComissoesPadrinho = async () => {
    try {
      isLoading.value = true
      const userData = getUserData()
      const padrinhoId = userData?.padrinho?.id

      if (!padrinhoId) {
        console.error('ID do padrinho não encontrado')
        return
      }

      console.log('Buscando comissões do padrinho ID:', padrinhoId)

      const response = await axios.get(`/comissao/padrinho/${padrinhoId}`)
      comissoesData.value = response.data.data || []
      
      console.log('Comissões do padrinho encontradas:', comissoesData.value.length)
      console.log('Amostra das comissões:', comissoesData.value.slice(0, 3))
      
      // Calcular estatísticas após buscar os dados
      calculateStats()
    } catch (error) {
      console.error('Erro ao buscar comissões do padrinho:', error)
    } finally {
      isLoading.value = false
    }
  }

  // Dados computados para estatísticas do padrinho
  const estatisticasPadrinho = computed(() => [
    {
      title: 'Usuários Apadrinhados',
      value: statsData.value.totalUsuariosApadrinhados.toString(),
      icon: 'FileTextIcon',
      color: 'primary',
    },
    {
      title: 'Comissões Totais',
      value: currency(statsData.value.comissaoTotal),
      icon: 'DollarSignIcon',
      color: 'success',
    },
    {
      title: 'Vendas de Apadrinhados',
      value: currency(statsData.value.totalVendasApadrinhados),
      icon: 'PackageIcon',
      color: 'warning',
    },
    {
      title: 'Pedidos Gerados',
      value: statsData.value.totalPedidosGerados.toString(),
      icon: 'ShoppingCartIcon',
      color: 'danger',
    },
  ])

  // Lista dos usuários apadrinhados (limitada para exibição)
  const usuariosResumo = computed(() => usuariosApadrinhados.value.slice(0, 6).map(usuario => ({
    id: usuario.id,
    nome: usuario.nome_reponsavel || 'Nome não informado',
    login: usuario.login,
    grupo: usuario.grupo?.grupousuario || 'Grupo não informado',
    status: usuario.ativo === 1 ? 'Ativo' : 'Inativo',
    statusVariant: usuario.ativo === 1 ? 'success' : 'secondary',
    dataInclusao: usuario.data_inclusao,
    dataAlteracao: usuario.data_alteracao,
  })))

  // Lista das últimas comissões recebidas
  const ultimasComissoes = computed(() => {
    const userData = getUserData()
    
    return comissoesData.value.slice(0, 5).map(comissao => {
      let valorComissao = 0
      
      // Calcular valor da comissão baseado no tipo de padrinho
      if (userData.padrinho.id === comissao.id_padrinho_afiliado) {
        valorComissao += Number(comissao.comissao_padrinho_afiliado) || 0
      }
      
      if (userData.padrinho.id === comissao.id_padrinho_vendedor) {
        valorComissao += Number(comissao.comissao_padrinho_vendedor) || 0
      }
      
      // Se não encontrou nos campos específicos, usar o campo genérico
      if (valorComissao === 0) {
        valorComissao = Number(comissao.comissao_padrinho) || 0
      }
      
      return {
        vendedor: comissao.pedido_item?.pedido?.usuario?.cliente?.nome || 'Vendedor não identificado',
        produto: comissao.pedido_item?.item?.item_nome || 'Produto não identificado',
        orderId: comissao.pedido_item?.pedido?.order_id || 'N/A',
        comissao: currency(valorComissao),
        valorTotal: currency(comissao.pedido_item?.valor_total_item || 0),
        status: comissao.pedido_item?.pedido?.status || 'Desconhecido',
        pago: comissao.pago ? 'Sim' : 'Não',
        dataInclusao: comissao.data_inclusao,
      }
    })
  })

  // Dados computados para o próximo pagamento
  const proximoPagamentoPadrinho = computed(() => {
    const valorAPagar = statsData.value.comissaoAPagar
    const proximaData = new Date()
    proximaData.setDate(proximaData.getDate() + 30) // 30 dias a partir de hoje
    
    return {
      data: proximaData.toLocaleDateString('pt-BR'),
      valor: currency(valorAPagar),
    }
  })

  // Função para processar dados do gráfico de comissões por mês
  const processChartDataPadrinho = () => {
    const comissoes = comissoesData.value
    const currentYear = new Date().getFullYear()
    const userData = getUserData()
    
    console.log('Processando dados do gráfico padrinho:', {
      totalComissoes: comissoes.length,
      anoAtual: currentYear,
      padrinhoId: userData?.padrinho?.id,
    })
    
    // Inicializar dados mensais para todos os 12 meses
    const monthlyData = Array.from({ length: 12 }, (_, index) => ({
      month: index,
      value: 0,
      count: 0,
    }))
    
    // Processar comissões por mês baseado na data_inclusao
    comissoes.forEach((comissao, index) => {
      if (comissao.data_inclusao) {
        try {
          const dataInclusao = new Date(comissao.data_inclusao)
          const year = dataInclusao.getFullYear()
          const month = dataInclusao.getMonth() // 0-11
          
          if (year === currentYear && month >= 0 && month < 12) {
            let valorComissao = 0
            
            // Calcular valor da comissão baseado no tipo de padrinho
            if (userData.padrinho.id === comissao.id_padrinho_afiliado) {
              valorComissao += Number(comissao.comissao_padrinho_afiliado) || 0
            }
            
            if (userData.padrinho.id === comissao.id_padrinho_vendedor) {
              valorComissao += Number(comissao.comissao_padrinho_vendedor) || 0
            }
            
            // Se não encontrou nos campos específicos, usar o campo genérico
            if (valorComissao === 0) {
              valorComissao = Number(comissao.comissao_padrinho) || 0
            }
            
            monthlyData[month].value += valorComissao
            monthlyData[month].count += 1
            
            console.log(`Comissão ${index + 1}: Mês ${month + 1}, Valor: R$ ${valorComissao.toFixed(2)}, Data: ${comissao.data_inclusao}`)
          }
        } catch (error) {
          console.error(`Erro ao processar data da comissão ${index}:`, error, comissao.data_inclusao)
        }
      }
    })
    
    console.log('Dados mensais padrinho processados:', monthlyData.map((item, index) => ({
      mes: index + 1,
      valor: `R$ ${item.value.toFixed(2)}`,
      quantidade: item.count,
    })))
    
    return monthlyData
  }

  // Dados computados para o gráfico de comissões do padrinho
  const chartDataComissoesPadrinho = computed(() => {
    const monthlyData = processChartDataPadrinho()
    const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    
    return {
      labels: monthNames,
      datasets: [
        {
          label: 'Comissões Padrinho (R$)',
          data: monthlyData.map(item => Number(item.value.toFixed(2))),
          borderColor: '#7367f0',
          backgroundColor: 'rgba(115, 103, 240, 0.1)',
          borderWidth: 2,
          pointRadius: 4,
          pointBackgroundColor: '#7367f0',
          pointBorderColor: '#fff',
          tension: 0.4,
          fill: true,
        },
      ],
    }
  })

  // Dados do gráfico de desempenho dos vendedores (baseado em dados reais)
  const chartDataDesempenhoVendedores = computed(() => {
    const currentDate = new Date()
    const currentWeek = []
    
    // Gerar os últimos 7 dias
    for (let i = 6; i >= 0; i -= 1) {
      const date = new Date(currentDate)
      date.setDate(date.getDate() - i)
      currentWeek.push(date.toLocaleDateString('pt-BR', { weekday: 'short' }))
    }
    
    // Processar dados reais de comissões por dia da semana
    const weeklyData = currentWeek.map((_, dayIndex) => {
      const targetDate = new Date(currentDate)
      targetDate.setDate(targetDate.getDate() - (6 - dayIndex))
      
      // Contar comissões do dia específico
      let dailyCommissions = 0
      comissoesData.value.forEach(comissao => {
        if (comissao.data_inclusao) {
          const comissaoDate = new Date(comissao.data_inclusao)
          if (comissaoDate.toDateString() === targetDate.toDateString()) {
            dailyCommissions += 1
          }
        }
      })
      
      return dailyCommissions
    })
    
    return {
      labels: currentWeek,
      datasets: [
        {
          label: 'Comissões Diárias',
          data: weeklyData,
          borderColor: '#28c76f',
          backgroundColor: 'rgba(40, 199, 111, 0.1)',
          borderWidth: 2,
          pointRadius: 4,
          pointBackgroundColor: '#28c76f',
          pointBorderColor: '#fff',
          tension: 0.4,
          fill: true,
        },
      ],
    }
  })

  // Opções dos gráficos
  const chartOptionsComissoesPadrinho = computed(() => ({
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          display: true,
          fontSize: 10,
          fontColor: '#b9b9c3',
          callback: value => `R$ ${value.toFixed(2).replace('.', ',')}`,
        },
        gridLines: {
          display: true,
          drawBorder: false,
          color: 'rgba(200, 200, 200, 0.2)',
        },
      }],
      xAxes: [{
        ticks: {
          display: true,
          fontSize: 10,
          fontColor: '#b9b9c3',
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      }],
    },
    elements: {
      point: {
        hoverRadius: 6,
      },
    },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      callbacks: {
        label: tooltipItem => {
          const value = tooltipItem.yLabel
          return `Comissões: R$ ${value.toFixed(2).replace('.', ',')}`
        },
      },
    },
  }))

  const chartOptionsDesempenhoVendedores = computed(() => ({
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          display: true,
          fontSize: 10,
          fontColor: '#b9b9c3',
        },
        gridLines: {
          display: true,
          drawBorder: false,
          color: 'rgba(200, 200, 200, 0.2)',
        },
      }],
      xAxes: [{
        ticks: {
          display: true,
          fontSize: 10,
          fontColor: '#b9b9c3',
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      }],
    },
    elements: {
      point: {
        hoverRadius: 6,
      },
    },
  }))

  // Dados das dicas para aumentar a rede
  const dicasRede = ref([
    {
      id: 1,
      titulo: 'Compartilhe seu link de indicação',
      texto: 'Dê a oportunidade para aqueles em que acredita.',
      icon: 'Share2Icon',
      color: 'primary',
      actions: [],
    },
    {
      id: 2,
      titulo: 'Acompanhe seus indicados',
      texto: 'Visualize quem entrou na plataforma pela sua indicação',
      icon: 'UsersIcon',
      color: 'success',
      actions: [],
    },
  ])

  // Lifecycle
  onMounted(() => {
    fetchComissoesPadrinho()
    fetchUsuariosApadrinhados()
  })

  return {
    // Estados
    isLoading,
    comissoesData,
    usuariosApadrinhados,
    statsData,
    
    // Dados computados
    estatisticasPadrinho,
    usuariosResumo,
    ultimasComissoes,
    proximoPagamentoPadrinho,
    
    // Dados dos gráficos
    chartDataComissoesPadrinho,
    chartDataDesempenhoVendedores,
    chartOptionsComissoesPadrinho,
    chartOptionsDesempenhoVendedores,
    
    // Dados das dicas
    dicasRede,
    
    // Métodos
    fetchComissoesPadrinho,
    fetchUsuariosApadrinhados,
    calculateStats,
  }
}
